/**
 * Runtime config for the generated API client (src/api/generated).
 *
 * Referenced from openapi-ts.config.ts (`runtimeConfigPath`) and called by
 * the generated client.gen.ts before the client is created.
 *
 * - baseUrl is the page origin because generated paths already include
 *   /api/v1, and the browser calls server.ts's same-origin /api proxy. (It
 *   must be absolute: `new Request("/api/...")` throws outside browsers,
 *   e.g. in tests.)
 * - auth delegates to whichever auth provider is active (MSAL or dev
 *   personas); they register themselves via setTokenProvider().
 * - throwOnError makes every SDK call reject with ApiError, which is what
 *   TanStack Query expects.
 */

import { getAccessToken } from "@/api/tokens";
import type { CreateClientConfig } from "./generated/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: globalThis.location?.origin ?? "",
  throwOnError: true,
  auth: async () => (await getAccessToken()) ?? undefined,
});
